import { Box, Grid } from '@mui/material';
import * as React from 'react';
import { VendorMapSelectControl } from './VendorMapSelect';
import { formatNumber } from '../Common/Utilities';
export function ProductionInvoiceDetailFields(props) {

	const fieldList = React.useMemo(() => {
		return [{
			label: 'Project/Job',
			type: 'string',
			field: 'level2Key',
			notVisible: false
		},
		{
			label: 'Activity',
			type: 'string',
			field: 'level3Key',
			notVisible: false
		},
		{
			label: 'Expense Type',
			type: 'string',
			field: 'rTypeName',
			notVisible: false
		},
		{
			label: 'Quantity',
			type: 'number',
			field: 'quantity',
			notVisible: false
		},
		{
			label: 'Amount',
			type: 'currency',
			field: 'ioInvoiceAmount',
			notVisible: false,
			//transformer: (value) => value && formatNumber(value)
		},
			//{
			//	label: 'Tax',
			//	type: 'text',
			//	notVisible: false
			//}
		]
	});

	return (<><div className="mf-12">
		<Box>
			{
				fieldList.map((item, index) => {
					return (!item.notVisible) ? <Grid container item key={index} spacing={props.style.mainRowSpacing} sx={props.style.mainRowStyle}>
						<Grid item key={'a' + index} xs={props.style.cellOneWidth} sx={props.style.cellOneStyle}><label>{item.label}</label></Grid>
						{
							< Grid item key={'b' + index} xs={props.style.cellTwoWidth}
								style={{ display: props.advanceEdit ? 'block' : 'none' }}
								sx={props.style.cellTwoStyle}>
								<VendorMapSelectControl
									style={props.style} fieldData={props?.fieldData}
									recordType={'Lineitems'}
									maxWeightedLine={props.maxWeightedLine}
									value={props?.mappedFields[item.field]}
									type={item.type}
									regex={props.regex}
									controlKey={'Detials' + index}
									onChange={(event) => {
										props.field_changehandler({ event: event, value: item.field })
									}}
								/>
							
							</Grid>
						}
						<Grid item key={'c' + index} xs={props.style.cellThreeWidth} sx={props.style.cellThreeStyle}>
							<input disabled type={'text'}
								className={`${(props.regex[item.type] || [])?.some(e => e.test(props?.mappedFields[item.field]?.value)) || item.type === 'string'
									|| (props?.mappedFields[item.field]?.value || '') === ''  ? '' : 'border-red'}`}
								value={item.transformer ? item.transformer(props?.mappedFields[item.field]?.value) : props?.mappedFields[item.field]?.value}
								style={{
									...props.style.inputStyle,
									textAlign: item.type.indexOf('currency') != -1 && props.regex['currency']?.some(e => e.test(props?.mappedFields[item.field]?.value)) ? 'right' : 'left'
								}} /></Grid>
					</Grid> : <></>
					//textAlign: (item.type === 'currency') ? 'right' : 'left'
				})
			}
		</Box>
	</div></>);
}